export default "__VITE_ASSET__B08qZo3T__"